import { createSelector } from '@ngrx/store';
import { getOrderInfoCompleteForLocationsByDate } from '@shared/state/commonSelectors/orderTypes';

export const getOrderInfoCompleteForLocationByDate = (locationNo: number, date: string | Date | null = null) =>
    createSelector(getOrderInfoCompleteForLocationsByDate(date), (locationsOrderInfo) => locationsOrderInfo.find((obj) => obj.locationNo === locationNo));
